<div *ngIf="selectedNotesTypes.length > 0">
    <div *ngFor="let notesType of selectedNotesTypes">
        <aum-expansion-panel>
            <aum-expansion-panel-header>
                <aum-panel-title>
                    {{ getTitleByCurrentLanguage(notesType.title) }}
                </aum-panel-title>
                <aum-panel-information>
                    {{ notesType.information[defaultLanguage] }}
                </aum-panel-information>
            </aum-expansion-panel-header>

            <aumico-notes-preview
                [currentLanguage]="currentLanguage"
                [viewMode]="viewMode"
                [componentOptions]="getComponentOptionsOfSelectedComponents(notesType.componentsOptions)"
                [componentList]="getSelectedComponentsNames(notesType.componentsOptions)"
            >
            </aumico-notes-preview>
        </aum-expansion-panel>
    </div>
</div>
